import { ExamSession } from "../types/types";
import { privateApiClient } from "../utils/axios.utils";
import { EXAM_SESSIONS_ENDPOINTS } from "../constants/api";

/**
 * Exam Session Service
 * This service handles all API calls related to exam sessions.
 */
export const ExamSessionService = {
  createExamSession: async (data: Partial<ExamSession>) => {
    const response = await privateApiClient.post(
      EXAM_SESSIONS_ENDPOINTS.CREATE,
      data
    );

    return response.data.data;
  },

  getCurrentExamSessions: async () => {
    const response = await privateApiClient.get(
      EXAM_SESSIONS_ENDPOINTS.GET_CURRENT
    );

    return response.data.data;
  },

  getAllExamSessions: async (limit?: number, page?: number) => {
    const params = limit !== undefined ? { limit, page } : { limit: 10, page: 1 };
    const response = await privateApiClient.get(
      EXAM_SESSIONS_ENDPOINTS.GET_ALL,
      { params }
    );

    return response.data.data;
  },

  updateExamSession: async (id: number, data: Partial<ExamSession>) => {
    const response = await privateApiClient.put(
      EXAM_SESSIONS_ENDPOINTS.UPDATE(id),
      data
    );

    return response.data.data;
  },

  deleteExamSession: async (id: number) => {
    const response = await privateApiClient.delete(
      EXAM_SESSIONS_ENDPOINTS.DELETE(id)
    );

    return response.data.data;
  },

  getExamSessionById: async (id: number) => {
    const response = await privateApiClient.get(
      EXAM_SESSIONS_ENDPOINTS.GET_BY_ID(id)
    );

    return response.data.data;
  },
};
